<div class="multiple-payment-method-area">
    <h2 class="title">{{ 'PAYMENT_METHOD' | translate }}</h2>
    <div class="block-items-2">
        <div
            class="items__select-area"
            #focusItems
            *ngFor="let method of methods; let last = last"
            [ngClass]="{ last: last }"
            [tabindex]="getTabIndex(method)"
            [attr.aria-checked]="isSelected(method)"
            (click)="select(method)"
            (keydown.enter)="select(method)"
            (keydown.space)="select(method)"
            (keydown.arrowleft)="movedLeft(method)"
            (keydown.arrowright)="movedRight(method)"
            (focus)="focused(method)"
            (keydown.arrowup)="movedLeft(method)"
            (keydown.arrowdown)="movedRight(method)"
            (blur)="blurred(method)"
            role="radio">
            <div class="wrapper-items__select-area">
                <div class="btn btn--selection" [ngClass]="{ selected: isSelected(method) }">
                    <div class="circle-icon">
                        <span class="icon icon-progress-check hidden"></span>
                    </div>
                    <div class="multiple-items-table">
                        <div class="multiple-items">
                            <div class="multiple-items__img">
                                <img
                                    class="dark:filter-yellow"
                                    *ngIf="env.PAYMENT_METHOD_USE_NAME"
                                    [alt]="method?.name"
                                    src="assets/pm_{{ method?.name?.toLowerCase()?.split(' ')?.join('_') }}.png" />
                                <img
                                    class="dark:filter-yellow"
                                    *ngIf="
                                        !env.PAYMENT_METHOD_USE_NAME &&
                                        method.payment_type !== 'S' &&
                                        method.code !== 'sveapay'
                                    "
                                    src="assets/pm_{{ method?.code }}.png"
                                    alt="" />
                                <mat-icon *ngIf="method.payment_type === 'S' && method.code === 'sveapay'"
                                    >account_balance</mat-icon
                                >
                            </div>

                            <div class="multiple-items__name">
                                <span *ngIf="!method.display">{{ method | translateObjectField: 'descr' : lang }}</span>
                                <span *ngIf="method.display">{{ method.display }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
